import React, { Component } from 'react';
import { compose } from 'recompose';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import InstagramStoriesMenu from 'dyzio-shared-components/lib/components/instagram-story-menu';
import InstagramStories from 'dyzio-shared-components/lib/components/instagram-stories';
import Pagination from 'dyzio-shared-components/lib/components/pagination';
import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';

const RESULTS_PER_PAGE = 5;

class InstagramStoriesTab extends Component {
  componentWillMount() {
    this.setState({
      currentPage: 1,
      totalPages: 1,
      storyData: [],
      searchTerm: '',
      loading: true,
    });
  }

  componentDidMount() {
    this.getStories();
    this.getCampaigns();
  }

  onPageIncrement = () => {
    const { currentPage, totalPages } = this.state;
    if (currentPage === totalPages) return;
    this.setState({
      currentPage: currentPage + 1,
    }, this.getStories);
  }

  onPageDecrement = () => {
    const { currentPage } = this.state;
    if (currentPage === 1) return;
    this.setState({
      currentPage: currentPage - 1,
    }, this.getStories);
  }

  onSearch = newSearch => {
    this.setState({
      searchTerm: newSearch,
      currentPage: 1,
    }, this.getStories);
  }

  getCampaigns = () => {
    const { jsonAPIClient, userInfo } = this.props;
    const { userId } = userInfo;

    jsonAPIClient.find('campaignPermission', { filter: { user: userId }, include: ['campaign'], sort: '-createdDate' })
      .then(permissions => {
        const campaignList = _.map(permissions, p => {
          const campaign = p.toJSONTree().campaign;
          return {
            key: campaign.id,
            text: campaign.name,
            value: campaign.id,
          };
        });
        // console.log(JSON.stringify(campaignList, null, 2));
        this.setState({
          campaignList,
        });
      });
  }

  handleAddStoryToCampaign = ({ storyId, selectedCampaignId }) => {
    console.log(`patch story ${storyId} with C: ${selectedCampaignId}`);
    const { restClient } = this.props;
    const patch = {
      data: {
        attributes: {
          campaign: {
            type: 'campaigns',
            id: selectedCampaignId,
          },
        },
      },
    };
    restClient.patch(`/stories/${storyId}`, patch)
      .then(() => {
        console.log('patched real good');
        this.getStories();
      });
  }

  getStoryUrl = ({ username, searchFilter, offset }) => {
    const url = '/stories?' +
    `filter[username]=${username}` +
    `&${searchFilter}` +
    '&sort=-publishedDate' +
    `&page[limit]=${RESULTS_PER_PAGE}&page[offset]=${offset}` +
    '&include=campaign';

    return url;
  }

  getStoryData = ({
    sortedData,
    included,
  }) => _.map(sortedData, d => {
    const includedCampaign = d.relationships.campaign.data;

    let campaign;
    if (includedCampaign) {
      const c = _.find(included, { id: includedCampaign.id });
      campaign = {
        id: c.id,
        name: c.attributes.name,
      };
    }

    return {
      id: d.id,
      ...d.attributes,
      campaign,
    };
  })

  getStories = () => {
    const { influencer, restClient } = this.props;
    const { currentPage, searchTerm } = this.state;
    const username = influencer.instagram;
    this.setState({
      isLoading: true,
      storyData: [],
    }, () => {
      const offset = (currentPage - 1) * RESULTS_PER_PAGE;
      const searchFilter = searchTerm === '' ? '' : `filter[caption]=:${searchTerm}`;

      // TODO - get campaign name into this list of stories
      const storyUrl = this.getStoryUrl({ username, searchFilter, offset });

      restClient
        .get(storyUrl)
        .then(response => {
          const { data: { data, meta, included } } = response;
          console.log(included);
          const sortedData = _.orderBy(data, 'attributes.publishedDate', 'desc');

          const storyData = this.getStoryData({ sortedData, included });
          this.setState({
            isLoading: false,
            hasFailed: false,
            totalPages: Math.ceil(meta.page.total / RESULTS_PER_PAGE),
            storyData,
          });
        }).catch(() => {
          this.setState({
            isLoading: false,
            hasFailed: true,
            storyData: [],
            totalPages: 1,
          });
        });
    });
  }

    getEmptyMessageText = () => {
      const { influencer } = this.props;
      const { searchTerm } = this.state;
      const username = influencer.instagram;
      return searchTerm ? `No search results for "${searchTerm}"` : `Dyzio is not capturing stories for ${username}`;
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    handleSubmit = () => this.setState({ email: '', name: '' })

    render() {
      const {
        currentPage, totalPages, storyData, isLoading, campaignList,
      } = this.state;
      const footerStyle = { minHeight: '5em', marginBottom: '5em' };
      return (
        <div className="page-content">
          <InstagramStoriesMenu
            currentPage={currentPage}
            totalPages={totalPages}
            onPageIncrement={this.onPageIncrement}
            onPageDecrement={this.onPageDecrement}
            onSearch={this.onSearch}
            isLoading={isLoading}
          />
          <InstagramStories
            stories={storyData}
            isLoading={isLoading}
            emptyMessageText={this.getEmptyMessageText()}
            campaignList={campaignList}
            onCampaignSelected={this.handleAddStoryToCampaign}
          />
          {isLoading || storyData.length === 0
            ? (<span />) :
            (<Segment style={footerStyle}>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageIncrement={this.onPageIncrement}
                onPageDecrement={this.onPageDecrement}
              />
            </Segment>)}
        </div>
      );
    }
}

InstagramStoriesTab.propTypes = {
  influencer: PropTypes.object.isRequired,
  restClient: PropTypes.func.isRequired,
};

export default compose(
  hasRESTClient,
  hasJSONAPIClient,
  hasUserInfo,
)(InstagramStoriesTab);



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-instagram-stories/index.js
 **/